<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16">グループ編集</strong>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form-group />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormGroup from '../../../components/FormComponents/Group'

export default {
  components: {
    FormGroup,
  },
}
</script>

<style>
.list-name {
  font-size: 1.5rem;
}
</style>
